import React from 'react';
import { useHistory } from 'react-router-dom';
import css from './Footer.module.css';
import { IconSocialMediaFacebook, IconSocialMediaTwitter, IconSocialMediaInstagram } from '../../../../components';

const Footer = () => {
  const history = useHistory();

  return (
    <footer className={css.footer}>
      <div className={css.container}>
        <div className={css.topSection}>
          <div className={css.brandSection}>
            <div className={css.brandContent}>
              <img
                className={css.logo}
                alt="Grounddz"
                src="/static/img/screenshot-2025-06-11-at-14-36-16-1-1.png"
                onClick={() => history.push('/')}
              />

              <p className={css.tagline}>
                Connecting the martial arts community
              </p>
            </div>

            <div className={css.socialLinks}>
              <a 
                href="https://www.facebook.com/profile.php?id=100094348629265" 
                target="_blank" 
                rel="noopener noreferrer"
                className={css.socialIcon}
              >
                <IconSocialMediaFacebook />
              </a>
              <a 
                href="https://x.com/grounddzplace" 
                target="_blank" 
                rel="noopener noreferrer"
                className={css.socialIcon}
              >
                <IconSocialMediaTwitter />
              </a>
              <a 
                href="https://www.instagram.com/grounddzplace/" 
                target="_blank" 
                rel="noopener noreferrer"
                className={css.socialIcon}
              >
                <IconSocialMediaInstagram />
              </a>
            </div>
          </div>

          <div className={css.linksSection}>
            <div className={css.linkColumn}>
              <div className={css.columnTitle}>Marketplace</div>
              <div 
                className={css.linkItem}
                onClick={() => history.push('/product?pub_listingType=product-selling')}
              >
                Browse gear
              </div>
              <div 
                className={css.linkItem}
                onClick={() => history.push('/l/new')}
              >
                Sell items
              </div>
            </div>

            <div className={css.linkColumn}>
              <div className={css.columnTitle}>Gyms</div>
              <div 
                className={css.linkItem}
                onClick={() => history.push('/gym?pub_listingType=gym')}
              >
                Find gyms
              </div>
              <div 
                className={css.linkItem}
                onClick={() => {
                  if (typeof window !== 'undefined') {
                    window.open('https://docs.google.com/forms/d/1-2UiuPWtuS1yn5BnrvI4du2-4I8B6xoFQP9O2OV-yGY/edit', '_blank', 'noopener,noreferrer');
                  }
                }}
              >
                Add your gym
              </div>
            </div>

            <div className={css.linkColumn}>
              <div className={css.columnTitle}>Support</div>
              <div 
                className={css.linkItem}
                onClick={() => history.push('/blog')}
              >
                Blog
              </div>
              <div 
                className={css.linkItem}
                onClick={() => history.push('/p/about')}
              >
                About us
              </div>
              <div 
                className={css.linkItem}
                onClick={() => history.push('/p/terms-of-service')}
              >
                Terms of Service
              </div>
              <div 
                className={css.linkItem}
                onClick={() => history.push('/p/privacy-policy')}
              >
                Privacy Policy
              </div>
            </div>
          </div>
        </div>

        <div className={css.bottomSection}>
          <p className={css.copyright}>
            © 2025 Grounddz LTD. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


